import React from "react"
import "./SummaryChartContent.styles.scss"
import { getReachPoints } from "./utils"
import { useIntl } from "react-intl"

interface SummaryChartContentProps {
	variationDifference: number
	textColor: string
}

const SummaryChartContent: React.FC<SummaryChartContentProps> = (props) => {
	const { variationDifference, textColor } = props
	const intl = useIntl()

	return (
		<>
			<div
				className={"chart-points"}
				style={{ color: textColor }}
				data-testid="penetration-content"
			>
				<span data-testid="penetration-points">
					{getReachPoints(variationDifference, intl)}
				</span>
				<span className="points-text">
					{intl.formatMessage({
						id:
							"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.chart.points",
					})}
				</span>
			</div>

			<div className="chart-text">
				{intl.formatMessage({
					id:
						"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.chart.text",
				})}
			</div>
		</>
	)
}

export default SummaryChartContent
